import { BillingMode } from '../../../../../services/exports/Constants';

export default {
  titles: {
    draft: 'Twoje zamówienie (koszt miesięcznie)',
    main: 'Twoja subskrypcja',
    billing_settings: 'Ustawienia rozliczeń',
  },
  form: {
    billing_mode: {
      label: 'Tryb rozliczania',
    },
    has_trial: {
      label: 'Dodaj dni próbne',
    },
    trial_days: {
      label: 'Ile dni próbnych ma być?',
      placeholder: '21',
      validation: {
        required: 'Liczba dni próbnych jest wymagana',
        min: '{{value}} to minimalna wartość dla dni próbnych',
        max: '{{value}} to maksymalna wartość dla dni próbnych',
      },
    },
  },
  fields: {
    created_at: 'Utworzono <strong>{{date}}</strong> przez <strong>{{manager}}</strong>',
    updated_at: 'Ostatnio zaktualizowano <strong>{{date}}</strong> przez <strong>{{manager}}</strong>',
    trial_ends_at: 'Okres próbny do <strong>{{date}}</strong>',
    trial_days:
      'Okres próbny {{trialDays}} dni rozpoczyna się w dniu uruchomienia; opłata zostanie naliczona po jego zakończeniu',
    resumable_until: 'Można wznowić do <strong>{{date}}</strong>',
    ended_at: 'Zakończono <strong>{{date}}</strong>',
    next_bill_at: 'Następna faktura <strong>{{date}}</strong>',
    product: 'Produkt',
    quantity: 'Ilość',
    price: 'Cena netto',
    tax: 'Podatek',
    amount: 'Kwota',
    net: 'Netto',
    tax_percentage: 'Podatek {{rate}}%',
    total: 'Łączna opłata miesięcznie',
  },
  billing_modes: {
    [BillingMode.Stripe]: 'Opłata z metody płatności',
    [BillingMode.InternalInvoicing]: 'Opłata ze sprzedaży',
  },
  labels: {
    included: 'wliczone',
    sales_based_discount:
      'W koszyku jest pozycja o zmiennej cenie; rzeczywista cena zostanie obliczona przy tworzeniu/aktualizacji subskrypcji na podstawie danych sprzedaży z poprzedniego miesiąca',
  },
  buttons: {
    edit: 'Edytuj',
    cancel: 'Anuluj',
    resume: 'Wznów',
  },
  modals: {
    cancel_subscription: {
      title: 'Anulować subskrypcję {{company}}?',
      description:
        'Spowoduje to anulowanie wybranej subskrypcji, w tym <strong>{{products}}</strong> (<strong>łączna kwota: {{total}}</strong>). Subskrypcja pozostaje aktywna i można ją wznowić do <strong>{{endsAt}}</strong>. Jeśli nie zostanie wznowiona do tego czasu, trzeba będzie utworzyć nową subskrypcję.',
    },
    resume_subscription: {
      title: 'Wznowić subskrypcję {{company}}?',
      description:
        'Spowoduje to wznowienie wybranej subskrypcji, w tym <strong>{{products}}</strong>. Restauracja jest obciążana kwotą <strong>{{total}}</strong> co miesiąc, następnym razem <strong>{{nextBillingDate}}</strong>.',
      description_prorated:
        'Spowoduje to wznowienie wybranej subskrypcji, w tym <strong>{{products}}</strong>. Pierwsza opłata w dniu <strong>{{nextBillingDate}}</strong> jest naliczana proporcjonalnie do 5. dnia miesiąca. Od tego czasu restauracja jest obciążana kwotą <strong>{{total}}</strong> piątego dnia każdego miesiąca.',
    },
  },
  toasts: {
    cancel_subscription:
      'Jeśli chcesz anulować subskrypcję, skontaktuj się telefonicznie lub e-mailem z osobą kontaktową {{provider}}. Twój kontakt natychmiast anuluje subskrypcję.',
    failed_to_cancel_subscription:
      'Coś poszło nie tak podczas anulowania subskrypcji. Skontaktuj się z pomocą techniczną',
    resume_subscription:
      'Jeśli chcesz wznowić subskrypcję, skontaktuj się telefonicznie lub e-mailem z osobą kontaktową {{provider}}. Twój kontakt natychmiast wznowi subskrypcję.',
    failed_to_resume_subscription:
      'Coś poszło nie tak podczas wznawiania subskrypcji. Skontaktuj się z pomocą techniczną',
  },
};
